import { fetcher } from '@commenda/utils';

export default async function getCsvHeaders(
  body: { file: { fileName: string; fileUrl: string } },
  token: string
) {
  const res = await fetcher(
    'csv/get-csv-headers',
    { method: 'POST', body },
    token
  );

  return res;
}
